<template>
	<div class="wrapper">
<!-- 		<iframe id="geoPage" width=0 height=0 frameborder=0  style="display:none;" scrolling="no"
		    src="https://apis.map.qq.com/tools/geolocation?key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&referer=shoudaole">
		</iframe> -->
		<div class="header"><BaseHeader :title="'领货点'" /></div>
		<div class="content">
			<van-sticky>
				<van-search show-action v-model="searchKey" shape="round" label="名称" placeholder="请输入领货点名称" @search="search">
					<template #action>
						<div style="color:#00BFFF;" @click="search">搜索</div>
					</template>
				</van-search>
				<div class="my-location">
					<span>当前位置</span>
					<span>{{ myLocation.address }}</span>
					<div style="float: right">
						<van-button type="primary" style="background-color: #00BFFF;border-color: #00BFFF" size="mini" @click="hadleGetLocation">刷新位置</van-button>
					</div>
				</div>
			</van-sticky>
			<div class="shop-box-receive">
				<div class="shop-list">
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
						<div class="shop-item" v-for="(item,index1) in shopList" :key="index1 + '-label'">
						    <div class="shop-img">
								<img v-lazy="item.logo"/>
							</div>
							<div class="shop-info" @click="handleGoDetails(item.id,item.dis_show)">
							    <p class="shop-name">{{item.shop_name}}</p>
							    <!-- <p class="shop-tel">{{item.shop_tel}}</p> -->
							    <p class="shop-tel">{{item.address}}</p>
							    <p class="shop-dis">距离您{{item.dis_show}}</p>
							</div>
							<div class="btn">
							    <span @click="handleGoLocation(item.lat,item.lng,item.shop_name,item.address)">去这里</span>
							</div>
						</div>
					</van-list>
				</div>
			</div>
		</div>

		<!-- <div class="footer"><TheFooterBar :active="3" /></div> -->
		<Loading :show="showLoading" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import BaseHeader from '../components/BaseHeader';
import { getReceiveShopListService } from '../service/basicService';
import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import { getWxSharService } from '../service/weChatService';
import { getAddressService } from '../service/untilService';
import Loading from '../components/Loading';
// import TheFooterBar from '../components/base/TheFooterBar';
// import Cookies from 'js-cookie';
import {isWeixinOrAlipayTools} from '../util/tools';
	//import {wecharShare} from "../util/weChat.js";

export default {
	name: 'ReceiveShopList',
	data() {
		return {
			myLocation: {
				// address:"北京市",
				// latitude:33.05614,
				// longitude:112.94793,
				address: '',
				latitude: 0,
				longitude: 0
			},
			shopList: [],
			loading: true,
			finished: false,
			offset: {
				page: 1,
				limit: 10
			},
			// active: 0,
			items: [{ id: 0, text: '离我最近' }],
			show: false,
			showLoading: false, //是否加载
			searchKey: '',
			index: 0
		};
	},
	mounted() {
		// this.getData();
		// this.showLoading = false;
		// this.show = true;
		// this.active = parseInt(Cookies.get('c_active')) || 0;
		// this.searchKey = Cookies.get('c_search') || '';
		// this.getLocation();
		this.getMyLocation();
		//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
	},
	methods: {
		// 设用户置位置到缓存
		// handleNav(index) {
		// 	// Cookies.set('c_active', index);
		// 	// this.search();
		// },
		// 重新获取位置-刷新页面
		hadleGetLocation() {
			window.location.reload();
		},
		getMyLocation() {
			var geolocation = new qq.maps.Geolocation();
			// geolocation.getIpLocation(this.showPosition, this.showErr);
			geolocation.getLocation(this.showPosition, this.showErr);//或者用getLocation精确度比较高
		},
		showPosition(position) {
			console.log(position);
			this.index = 1;
			this.myLocation.latitude = position.lat;
			this.myLocation.longitude = position.lng;
			// this.myLocation.address = position.city+position.addr;
			var str = position.addr;
			str = str.slice(0,15)+'...';
			this.myLocation.address = str;
			this.getData();
			this.show = true;
			this.showLoading = false;
			// this.setMap();
		},
		showErr() {
			console.log("定位失败");
			this.getMyLocation();//定位失败再请求定位，测试使用
		},
		//获取当前位置
		getLocation() {
			this.index = 1;
			// this.getData();return;
			const that = this;
			getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
				if (result.status === 1) {
					wx.config({
						// debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: result.datas.appId, // 公众号名称，由商户传入
						timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
						nonceStr: result.datas.nonceStr, // 随机串
						signature: result.datas.signature, // 微信签名
						jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表
					});
					wx.ready(function() {
						wx.getLocation({
							type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
							success: function(res) {
								// console.log(res);
								that.myLocation.latitude = res.latitude;
								that.myLocation.longitude = res.longitude;
								getAddressService(res.latitude, res.longitude)
									.then(data => {
										if (data.status === 1) {
											that.myLocation.address = data.datas.result.formatted_address;
											that.getData();
											that.show = true;
											that.showLoading = false;
										} else {
											Toast(data.msg);
										}
									})
									.catch(err => {
										that.showLoading = false;
										console.log(err);
									})
									.finally(() => {
										that.showLoading = false;
									});
							}
						});
					});
				} else {
					Toast(result.msg);
				}
			});
		},

		search() {
			this.loading = false;
			this.finished = false;
			this.shopList = [];
			this.offset.page = 1;
			this.show = false;
			// Cookies.set('c_search', this.searchKey || '');
			// this.getData();
		},

		getData() {
			if (this.index == 0) {
				return;
			}
			if (this.myLocation.latitude === 0 || this.myLocation.longitude === 0) {
				Toast('位置信息获取失败，请刷新重试');
				return;
			}
			getReceiveShopListService(this.myLocation.latitude, this.myLocation.longitude, this.offset.page, this.offset.limit, this.searchKey)
				.then(res => {
					if (res.status === 1) {
						this.shopList = [...this.shopList, ...res.datas];
						console.log(this.shopList);
						// if(this.offset.page === 2){
						//     this.getData();
						// }
						if (res.datas.length !== this.offset.limit) {
							this.finished = true;
							return;
						}
						this.offset.page++;
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
					this.showLoading = false;
				});
		},

		handleGoLocation(lat, lng, name, address) {
			const isWeixinOrAlipay = isWeixinOrAlipayTools();
			if(isWeixinOrAlipay === 'WeiXIN'){
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					if (result.status === 1) {
						wx.config({
							// debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: result.datas.appId, // 公众号名称，由商户传入
							timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
							nonceStr: result.datas.nonceStr, // 随机串
							signature: result.datas.signature, // 微信签名
							jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表
						});
						wx.ready(function() {
							wx.openLocation({
								latitude: parseFloat(lat), //目的地latitude
								longitude: parseFloat(lng), //目的地longitude
								name: name,
								address: address,
								scale: 15 //地图缩放大小，可根据情况具体调整
							});
						});
					} else {
						Toast(result.msg);
					}
				});
			}else{
				// 腾讯
				// var backurl = "http://www.shoudaole.cn/dist/#/receiveShopList";
				var url = "https://apis.map.qq.com/tools/routeplan/eword="+address+"&epointx="+lat+"&epointy="+lng+"&topbar=1?referer=收到乐&key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&back=0";
				/*百度*/
				// var url ="http://api.map.baidu.com/marker?location=34.271454,108.958486&title=百度导航&content="+address+"&output=html&src=yellowpage";
				// $("#mapBg .mapTab .mapBtn_b").attr("href",mapUrl_bd);
				window.location.href=url;
				return;
			}
			// window.location.href = 'http://api.map.baidu.com/geocoder?address=' + address + '&output=html&src=webapp.baidu.openAPIdemo';
		},

		handleGoDetails(shopId, distance) {
			console.log(distance);
			this.$router.push({
				name: 'receiveShopDetail',
				params: {
					shopId,
					distance
				}
			});
		}
	},
	computed: {
		...mapState({
			userId: state => state.userInfo.userId
		})
	},
	destroyed() {
		// Cookies.remove('c_search');
	},
	components: {
		BaseHeader,
		Loading
		// TheFooterBar
	}
};
</script>

<style scoped lang="scss">
.wrapper {
	.content {
		padding-bottom: 50px;
		min-height: 100px;
		.my-location {
			background: #ffffff;
			padding: 10px;
			box-sizing: border-box;
			span:nth-child(2) {
				margin-left: 10px;
				color: #999999;
			}
		}
		.shop-box-receive {
			box-sizing: border-box;
			.shop-list{
				box-sizing: border-box;
				.shop-item{
					display: flex;
					background: #ffffff;
					border-radius: 10px;
					align-items: center;
					justify-content: space-around;
					padding: 10px;
					box-sizing: border-box;
					margin-bottom: 5px;
					margin-top: 5px;
					// box-shadow: 1px 1px 1px #ccc,
					//                 -1px -1px 1px #ccc;
					.shop-img{
						width:30%;
						margin-right:5px;
						img{
							width: 100px;
							// height: 100px;
							border-radius: 10px;	
						}
					}
					.shop-info{
						width:55%;
					    .shop-name{
					        /*width: 200px;*/
					        color: #000000;
					        font-size: 14px;
					        text-overflow: ellipsis;
					        overflow: hidden;
					        white-space: nowrap;
					        font-weight: 800;
							padding: 3px 0;
					    }
					    .shop-tel{
					        padding: 3px 0;
					        color: #666666;
					    }
						.shop-dis{
						    padding: 3px 0;
						    color: #00BFFF;
						}
					}
					.btn{
						width:15%;
						text-align: center;
					    span{
					        white-space: nowrap;
					        background: #00BFFF;
					        color: #ffffff;
					        padding: 5px;
					        box-sizing: border-box;
					        border-radius: 20px;
					        font-size: 12px;
					    }
					}
				}
			}
		}
	}
}
</style>